// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import ProjectDetail from './ProjectDetail';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#0a0d14',
      paper: '#0f172a', // zinc-900 / slate-900 hybrid glass basis
    },
    text: {
      primary: '#f8fafc', // slate-50
      secondary: '#94a3b8', // slate-400
    },
    primary: {
      main: '#6366f1', // Indigo-500
    },
    secondary: {
      main: '#22d3ee', // Cyan-400
    },
  },
  typography: {
    fontFamily: 'Inter, "Plus Jakarta Sans", -apple-system, sans-serif',
    h1: {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 800,
    },
    h2: {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 700,
    },
    h3: {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 700,
    },
    h4: {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 700,
    },
    h5: {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 600,
    },
    h6: {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 600,
    },
    body1: {
      fontFamily: 'Inter, sans-serif',
    },
    body2: {
      fontFamily: 'Inter, sans-serif',
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project/:id" element={<ProjectDetail />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
